import { useSelector } from "react-redux";
import { StoreState } from "../models/states/StoreState";

export default function useQuestionnaire() {
    return useSelector((state: StoreState) => state.interview.questionnaire);
}
